// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-F":"TabF_outdoor-recreation-F__7Dolr"};